<h1>
  {{ file.filename }}
</h1>

<p><b>Mimetype:</b> {{ file.mimetype }}</p>
<p><b>Size:</b> {{ file.size }}</p>
<p><b>Created At:</b> {{ file.createdAt.$date }}</p>
<p><b>File Data:</b> {{ file.filedata }}</p>
